export function isCPDisabled(status: string) {
  return !['active', 'upgradecomplete', 'upgrading'].includes(status);
}
